import React, { Component, Fragment } from 'react';
import axios from 'axios';

import BlacklinePost from '../components/BlacklinePost';

import Header from '../components/Header';

class Selecao extends Component {
  state = {
    leftSide: null,
    rightSide: null,
    isLoading: false,
    newsError: [],
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    axios
      .get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=3')
      .then((response) => {
        let dataArray = response.data.reverse();
        let half_dataArray = Math.ceil(dataArray.length / 2);

        this.setState({
          isLoading: false,
          leftSide: dataArray.slice(0, half_dataArray),
          rightSide: dataArray.slice(half_dataArray, dataArray.length),
        });
      })
      .catch((error) =>
        this.setState({
          dataError: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { leftSide, rightSide, isLoading } = this.state;

    let leftPosts =
      leftSide !== null && isLoading === false ? (
        leftSide.map((leftPost) => (
          <BlacklinePost
            key={leftPost.id}
            title={leftPost.title.rendered}
            body={leftPost.content.rendered}
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    let rightPosts =
      rightSide !== null && isLoading === false ? (
        rightSide.map((rightPost) => (
          <BlacklinePost
            key={rightPost.id}
            title={rightPost.title.rendered}
            body={rightPost.content.rendered}
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    return (
      <Fragment>
        <Header title={'Seleção de Formandos'} />

        <section className="content">
          <div className="column"> {leftPosts}</div>
          <div className="column">{rightPosts}</div>
        </section>
      </Fragment>
    );
  }
}

export default Selecao;
